<template>
  <div class="search-name-container">
    <div class="search-name">
      <input :value="searchInput"
             @input="updateSearchInput"
             type="text"
             data-cy="search-input"
             class="search-input"
             :placeholder="$t('search.search.search')"
             @keyup.enter="search"
      />
      <img @click="reset"
           alt="close-icon"
           class="close-icon"
           src="@/assets/CloseMed.svg"
      />
      <img @click="search"
           alt="search-icon"
           class="search-icon"
           src="@/assets/SearchIcon.svg"
      />
    </div>
  </div>
</template>

<script>

export default {
  name: 'SearchInput',
  computed: {
    searchInput() {
      return this.$store.getters.searchInput
    }
  },
  props: {
    type: {
      type: String,
      default: () => undefined
    }
  },
  methods: {
    search() {
      this.$store.dispatch('search', { searchInput: this.searchInput, type: this.type })
    },
    updateSearchInput(e) {
      this.$store.commit('updateSearchInput', e.target.value)
    },
    reset() {
      this.$store.dispatch('resetSearch')
    }
  }
}

</script>

<style scoped lang="scss">

.search-name-container {
  min-width: 600px;
  max-width: 960px;
  width: 100%;

  @media (max-width: $small) {
    min-width: auto;
  }

}

.search-name {
  position: relative;
  height: 33px;
  width: 405px;
  margin: 30px auto;

  @media (max-width: $small) {
    width: calc(100% - 10px);
    margin: 5px;
  }

    .search-input {
    border: 1px solid #D8D8D8;
    border-radius: 3px;
    min-height: 31px;
    width: 326px;
    padding: 0 60px 0 10px;
    font-size: 15px;

    @media (max-width: $small) {
        width: calc(100% - 70px);
      }
  }

  .close-icon {
    position: absolute;
    right: 40px;
    top: 5px;
    cursor: pointer;
  }

  .search-icon {
    position: absolute;
    right: 10px;
    top: 5px;
    cursor: pointer;
  }
}
</style>
